import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

import { SettingsTable } from '../../../components/settings-table/settings-table';
import { ApiKeyItem } from './api-key-item';
import { ApiKey, fetchApiKeys, revokeApiKey } from '../store/api-key.slice';

const headers = ['Name', 'Key', 'Created', 'Last used', ''];

type ApiKeyListProps = {
  newKey?: ApiKey | null;
};

export const ApiKeyList: React.FC<ApiKeyListProps> = ({ newKey }) => {
  const [apiKeys, setApiKeys] = useState<ApiKey[]>([]);

  const load = useCallback(async () => {
    const keys = await fetchApiKeys();
    setApiKeys(keys);
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    if (newKey) {
      setApiKeys((prev) => {
        if (prev.some((k) => k._id === newKey._id)) return prev;
        return [...prev, newKey];
      });
    }
  }, [newKey]);

  const handleRevoke = async (apiKeyId: string) => {
    await revokeApiKey(apiKeyId);
    setApiKeys((prev) => prev.filter((key) => key._id !== apiKeyId));
  };

  return (
    <Container>
      <SettingsTable headers={headers}>
        {apiKeys.map((apiKey) => (
          <ApiKeyItem key={apiKey._id} apiKey={apiKey} onRevoke={handleRevoke} />
        ))}
      </SettingsTable>
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  padding: 1.6rem;
`;
